import axios from "axios";
import { createContext, useContext, useEffect, useReducer, useState } from "react";
// import reducer from "../reducer/UserReducer";
import secureLocalStorage from "react-secure-storage";

const UserContext = createContext();


const AppProvider = ({ children }) => {
    // const [state, dispatch] = useReducer(reducer, initailState);
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'))
    const [auth_data, setAuth] = useState(null);

    const getAuth = async () => {
        if (!auth) return;

        try {
            const response = await axios.get(
                `https://buzzinguniverse.com/backend/api/get-user-data/${auth?.id}`
            );
            setAuth(response.data.data?.data);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const [tabb, setTabb] = useState('activity');
    const [groupTab, setGroupTab] = useState('home');

    const [myFreinds, setMyFreinds] = useState(null);
    const [myPendingRequests, setMyPendingRequests] = useState([]);
    const [mySentRequests, setMySentRequests] = useState([]);

    const [freinds, setFreinds] = useState(null);
    const [request, setRequests] = useState(null);
    const GetFreindsRequests = async (userId, type) => {
        try {
            const response = await axios.post("https://buzzinguniverse.com/backend/api/friend-list",
                { userid: userId, type: type },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                if (type === 1) {
                    setRequests(response.data.data || []);
                } else if (type === 2) {
                    setFreinds(response.data.data || []);
                }
            } else {

            }
        } catch (error) {
            console.error("Error updating user:", error);
        } finally {

        }
    };

    const GetMyFreinds = async (type) => {
        try {
            const response = await axios.post("https://buzzinguniverse.com/backend/api/friend-list",
                { userid: auth?.id, type: type },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                setMyFreinds(response.data.data || [])
            } else {

            }
        } catch (error) {
            console.error("Error updating user:", error);
        } finally {

        }
    };

    const fetchMyPendingRequests = async () => {
        if (!auth?.id) return;
        try {
            const response = await axios.post("https://buzzinguniverse.com/backend/api/friend-list",
                { userid: auth.id, type: 1 },
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            if (response.status === 200) {
                const all = response.data.data || [];
                setMyPendingRequests(all.filter(r => r.data.user_id_two == auth.id));
                setMySentRequests(all.filter(r => r.data.user_id_one == auth.id));
            }
        } catch (error) {
            console.error("Error fetching pending requests:", error);
        }
    };

    const Notify = async (user_id, notification_text, notification_link) => {
        if (user_id == auth.id) return false;
        try {
            const response = await axios.post("https://buzzinguniverse.com/backend/api/create-notification-request",
                { user_id, notification_text, notification_link },
            );
        } catch (error) {
            console.error("Error updating user:", error);
        } finally {

        }
    };

    // Update active_time every 45 seconds so online threshold (2 min) is never missed
    useEffect(() => {
        let interval;
        if (auth?.id) {
            const setUserActiveTime = async () => {
                try {
                    await axios.post("https://buzzinguniverse.com/backend/api/set-user-active-time", {
                        userid: auth.id,
                        status: 1,
                    });
                } catch (error) {
                    console.error("Error setting user active time:", error);
                }
            };

            setUserActiveTime();
            interval = setInterval(setUserActiveTime, 45000);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [auth?.id]);

    useEffect(() => {
        if (auth) {
            GetMyFreinds(2);
            getAuth();
            fetchMyPendingRequests();
            const interval = setInterval(fetchMyPendingRequests, 30000);
            return () => clearInterval(interval);
        } else {
            setAuth({});
        }
    }, [])

    return <UserContext.Provider value={{ groupTab, setGroupTab, setTabb, tabb, GetFreindsRequests, freinds, request, myFreinds, myPendingRequests, mySentRequests, fetchMyPendingRequests, auth_data, getAuth, Notify }} > {children} </UserContext.Provider>
};

const useUserContext = () => {
    return useContext(UserContext);
}
export { AppProvider, UserContext, useUserContext };
